import script from "./SectionEmpathy.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionEmpathy.vue?vue&type=script&setup=true&lang=js"

import "./SectionEmpathy.vue?vue&type=style&index=0&id=5a87296e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a87296e"]])

export default __exports__